import { render, staticRenderFns } from "./DeleteBookingDateModal.vue?vue&type=template&id=2546fbb8&"
import script from "./DeleteBookingDateModal.vue?vue&type=script&lang=js&"
export * from "./DeleteBookingDateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports